import { Component } from '@angular/core';
import { ApplicationFormFieldCardComponent } from '../irembogov-application-form-field-card/application-form-field-card.component';

@Component({
  standalone: false,
  selector: 'irembogov-application-generic-form-field-card',
  templateUrl: './irembogov-application-generic-form-field-card.component.html',
  styleUrls: ['./irembogov-application-generic-form-field-card.component.scss'],
})
export class IrembogovApplicationGenericFormFieldCardComponent extends ApplicationFormFieldCardComponent {}
